var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlutterinline = function SvgFlutterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flutter_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#44D1FD",
    d: "M9.414.005 14.366 0 6.057 8.314l-2.165 2.155L1.428 8zm-.047 7.423c.065-.085.183-.043.273-.054l4.722.002-4.304 4.304-2.476-2.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1FBCFD",
    d: "m5.113 11.683 2.469-2.468 2.477 2.464.01.01-2.486 2.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08589C",
    d: "m7.582 14.157 2.486-2.466 4.296 4.304c-1.618.004-3.236 0-4.853.003-.092.02-.15-.064-.208-.116z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFlutterinline;